import { useNavigate } from "react-router-dom";
import { trackAffiliateClick } from "@/lib/api";

const PILLS = [
  { label: "All", tag: "" },
  { label: "Watching Now", icon: "🔥", jump: "watching-now" },
  { label: "Arcade", icon: "🕹️", to: "/games" },
  { label: "Shorts", icon: "⏱️", to: "/shorts" },
  { label: "Dispensary", lead: "🍁", href: "https://thcasmallbuds.com/?ref=LEAVERHALL", provider: "dispensary" },
  { label: "Action", tag: "action" },
  { label: "Horror", tag: "horror" },
  { label: "Comedy", tag: "comedy" },
  { label: "Sci-Fi", tag: "sci-fi" },
  { label: "Thriller", tag: "thriller" },
  { label: "Drama", tag: "drama" },
  { label: "Romance", tag: "romance" },
  { label: "Anime", tag: "anime" },
  { label: "Animation", tag: "animation" },
  { label: "Sports", tag: "sports" },
  { label: "Knicks", lead: "🏀", tag: "knicks", team: true },
  { label: "90s Toons", tag: "90s toons" },
  { label: "Urban Cinema", tag: "urban cinema" },
  { label: "Podcasts", tag: "podcasts" },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

// External sponsor link (new tab), visually set apart from internal filters.
const SponsorPill = ({ p }) => (
  <a
    href={p.href}
    target="_blank"
    rel="noopener noreferrer"
    tabIndex={0}
    onClick={() => trackAffiliateClick({ provider: p.provider, title: p.label })}
    data-testid={`genre-pill-${slug(p.label)}`}
    className="rv-pill shrink-0 whitespace-nowrap rounded-full border border-emerald-500/50 bg-emerald-500/[0.08] px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.14em] text-emerald-300 transition-colors duration-300 hover:border-emerald-400 hover:bg-emerald-500/20 focus:outline-none"
  >
    <span className="mr-1.5" aria-hidden="true">{p.lead}</span>
    {p.label}
  </a>
);

// Non-wrapping quick-filter pills directly under the header (D-pad reachable via data-genre-bar).
export const GenreQuickBar = ({ active, onPick }) => {
  const navigate = useNavigate();
  const current = (active || "").toLowerCase();
  const click = (p) => {
    if (p.to) return navigate(p.to);
    if (p.jump) {
      onPick("");
      setTimeout(() => document.getElementById(p.jump)?.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      return;
    }
    onPick(p.tag);
  };
  return (
    <nav data-genre-bar data-testid="genre-quick-bar" aria-label="Quick genres" className="flex gap-2 overflow-x-auto hide-scrollbar px-4 sm:px-8 pt-2.5 pb-1 mx-auto max-w-[1600px] min-[2200px]:max-w-[2200px]" style={{ overscrollBehaviorX: "contain" }}>
      {PILLS.map((p) => {
        if (p.href) return <SponsorPill key={p.label} p={p} />;
        const on = !p.to && !p.jump && current === p.tag;
        return (
          <button
            key={p.label}
            type="button"
            tabIndex={0}
            data-testid={`genre-pill-${slug(p.label)}`}
            aria-pressed={on}
            onClick={() => click(p)}
            className={`rv-pill shrink-0 whitespace-nowrap rounded-full border px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.14em] transition-colors duration-300 focus:outline-none ${
              p.team
                ? on ? "border-[#F58426] bg-[#006BB6] text-white" : "border-[#F58426]/70 bg-[#006BB6]/25 text-[#FFB070] hover:bg-[#006BB6] hover:text-white"
                : on ? "border-amber bg-amber text-black" : "border-white/15 bg-white/[0.03] text-white/70 hover:border-amber hover:text-amber"
            }`}
          >
            {p.lead && <span className="mr-1.5" aria-hidden="true">{p.lead}</span>}
            {p.label}
            {p.icon && <span className="ml-1.5" aria-hidden="true">{p.icon}</span>}
          </button>
        );
      })}
    </nav>
  );
};
